/** Dated meter values shared by inline previews and component cards. */
import { type ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { type AssetTreeNode } from "./queries";
import { formatDateTime, formatQuantity } from "@/shared/lib/format";

/** Never present a missing or undated reading as a current measurement. */
export function AssetMeterSummary({ meters }: { meters: AssetTreeNode["meters"] }): ReactElement {
  const { t } = useTranslation();
  return (
    <>
      {(meters ?? []).map((meter) => (
        <p key={meter.id} className="mt-1 text-sm">
          {meter.name}:{" "}
          {meter.current_at == null
            ? t("assets.summary.noReading")
            : `${formatQuantity(meter.current_value)} ${meter.unit}`}
          {meter.current_at ? (
            <span className="ms-2 text-xs text-muted-foreground">
              {formatDateTime(meter.current_at)}
            </span>
          ) : null}
        </p>
      ))}
    </>
  );
}
